module.exports = __webpack_public_path__ + "img/刷卡读卡器.9711ce0b.jpg";